import Spine from 'core/display/Spine'
import { pointsOnBezierCurves } from 'points-on-curve'
import { curveToBezier } from 'points-on-curve/lib/curve-to-bezier.js'
import { signal } from 'services/SignalsService'
import { animation, lineSetting, typeLine } from 'settings/custom/lines'
import { Device } from 'utils/Device'
import { LinePoints } from 'utils/LinePoints'
import { create } from 'utils/Object'
import { sortLine } from 'utils/SortLine'
import { showHide } from 'utils/Tweens'

import PolyLine from '../PolyLine'

export default class LinesEntity extends PIXI.Container {
  constructor() {
    super()
    this.builder = new LinePoints()
    this.lines = []
    this.count = game.models.SpinModel.get().lines
    this.paths = sortLine(game.models.SpinModel.get().paths)

    signal.on('LINES:SHOW', this.showLine.bind(this))
    signal.on('LINES:HIDE', this.hideLines.bind(this))
  }

  register = (type, object, data) => {
    if (type === 'LinesContainer') {
      for (let i = 0; i < this.count; i++) {
        if(typeLine === 'polyline'){
          /**
           * Points should be array [[0, 195] ,[55, 195] ,[165, 195] ,[275, 195] ,[385, 195] ,[495, 195] ,[550, 195]]
           * Just remove Pixi Point   from Line point
           * curveToBezier(points, forceCurve(0-0.9))
           */
          const points = this.builder.create(this.paths[i + 1], i)
          /**
           * Remove element what we dont need convert to curve
           */
          const firstPoint = points.shift()
          const lastPoint  = points.pop()

          /**
           * Made curve transformation your Point use https://www.npmjs.com/package/points-on-curve
           */
          const transformToCurve =  curveToBezier(points, 0.9)
          const transformBezier = pointsOnBezierCurves(transformToCurve)

          transformBezier.unshift(firstPoint)
          transformBezier.push(lastPoint)

          /**
           * Convert Curve Point to PIXI Point
           */
          const convertPoint = transformBezier.map((arr) =>  {
            return new PIXI.Point(arr[0], arr[1])
          })

          const rope = new PolyLine({ texture: game.assets.main.atlas[lineSetting.texture], points: convertPoint })

          if ( lineSetting.blendMode) {
            rope.blendMode = lineSetting.blendMode
          }

          if ( lineSetting.alpha) {
            rope.alpha = lineSetting.alpha
          }

          this.lines.push(rope)
          rope.visible = false
          object.addChild(rope)
        }
        else if (typeLine === 'spine'){
          const spine = new Spine(create(data, animation))
          spine.scale.set(Device.isDesktop() ? 1 : 0.5)
          this.lines.push(spine)
          spine.visible = false
          object.addChild(spine)
        }
      }
    }
  }

  showLine(id) {
    const animSetting = lineSetting.animation

    if (id) {
      id = parseFloat(id)
      this.lines[id - 1].visible = true
      this.lines[id - 1].alpha = 0

      if(animSetting){
        showHide(this.lines[id - 1], animSetting.alpha, animSetting.in, animSetting.end, animSetting.delay)
      }

      if(typeLine === 'spine'){
        this.lines[id - 1].play(`line-${id}`, true)
      }
    }
  }

  hideLines() {
    for (let i = 0; i < this.count; i++) {
      this.lines[i].visible = false
      if(typeLine === 'spine'){
        this.lines[i].stop()
      }
    }
  }
}
